import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { sanitizeBackendHtml } from '@/lib/security/sanitize-html';
import { ImageButton } from './image-button';
type Props = {
  html?: string | null;
  images?: {
    url: string;
  }[] | null;
  onImageClick?: (images: {
    url: string;
  }[], index: number) => void;
};
export function AccommodationDetailSection(t0) {
  const $ = _c(11);
  const {
    html,
    images,
    onImageClick
  } = t0;
  if (!html) {
    return null;
  }
  const hasImages = !!images?.length;
  let t1;
  if ($[0] !== html) {
    t1 = sanitizeBackendHtml(html);
    $[0] = html;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="html-text" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hasImages || $[5] !== images || $[6] !== onImageClick) {
    t3 = hasImages && <div className="grid grid-cols-6 gap-4 sm:gap-8">{images.slice(0, 3).map((image, index) => <ImageButton onClick={() => onImageClick?.(images, index)} key={image.url} className="col-span-3 aspect-4/3 grow overflow-hidden rounded-xl bg-primary-green only:col-span-6 [&:first-child:nth-last-child(3)]:col-span-6"><Image src={image.url} alt={image.url} width={768} height={576} className="!relative !h-full object-cover" /></ImageButton>)}</div>;
    $[4] = hasImages;
    $[5] = images;
    $[6] = onImageClick;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="grid gap-6 md:gap-12">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}